module.exports = __webpack_public_path__ + "static/img/m_name.abd4ee0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/cz/m_name.png
// module id = DuFM
// module chunks = 7